import { Chip } from '@mui/material';


export const DownloadChip = ({ label, url }) => {
    const handleDownload = () => {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', url.split('/').pop()); 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);  
    };

    return (
      <Chip
        label={label}
        color='success'
        variant="filled"
        onClick={handleDownload}
      />
    );
  };